import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RankingsRoutingModule } from './rankings-routing.module';
import { RankingsListComponent } from './rankings-list/rankings-list.component';
import { RankingsCreateComponent } from './rankings-create/rankings-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [RankingsListComponent, RankingsCreateComponent],
  imports: [
    CommonModule,
    RankingsRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class RankingsModule { }
